import { formatDate } from '../../../utils/formatDate'
import apinode from '../../apinode'

class WMSRelatorioService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async ocupacaoEndereco() {
    const response = await apinode.get(
      `/wms-relatorio/ocupacao-por-endereco/${this.idconta}`,
    )

    return response.data
  }

  async ocupacao() {
    const response = await apinode.get(
      `/wms-relatorio/ocupacao/${this.idconta}`,
    )

    return response.data
  }

  async estoqueNegativo() {
    const response = await apinode.get(
      `/wms-relatorio/estoque-negativo/${this.idconta}`,
    )

    return response.data
  }

  async produtividade(startDate, endDate) {
    const startDateFormatted = formatDate(startDate, 'yyyy-MM-dd')
    const endDateFormatted = formatDate(endDate, 'yyyy-MM-dd')

    const response = await apinode.get(
      `/wms-relatorio/produtividade/${this.idconta}?startDate=${startDateFormatted}&endDate=${endDateFormatted}`,
    )

    return response.data
  }

  async compactarEnderecos() {
    const response = await apinode.get(
      `/wms-relatorio/compactar-enderecos/${this.idconta}`,
    )

    return response.data
  }

  async capacidadePicking() {
    const response = await apinode.get(
      `/wms-relatorio/capacidade-picking/${this.idconta}`,
    )

    return response.data
  }

  async estoquePorEndereco() {
    const response = await apinode.get(
      `/wms-relatorio/estoque-por-endereco/${this.idconta}`,
    )

    return response.data
  }

  async estoquePorProduto() {
    const response = await apinode.get(
      `/wms-relatorio/estoque-por-produto/${this.idconta}`,
    )

    return response.data
  }

  async historicoMovimentacao(sku) {
    const response = await apinode.get(
      `/wms-relatorio/historico-movimentacao/${this.idconta}?sku=${sku}`,
    )

    return response.data
  }
}

export default new WMSRelatorioService()
